import { render, staticRenderFns } from "./modal-add-brand.vue?vue&type=template&id=813a1986&scoped=true&"
import script from "./modal-add-brand.vue?vue&type=script&lang=js&"
export * from "./modal-add-brand.vue?vue&type=script&lang=js&"
import style0 from "./modal-add-brand.vue?vue&type=style&index=0&id=813a1986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813a1986",
  null
  
)

export default component.exports